module.exports = __webpack_public_path__ + "static/widget-img-6-34d417b46bf9c680245e428507c1c2f5.png";